import Vue from 'vue'
import Router from 'vue-router'
import routeNames from './routes'
import store from '@/store'
import { BASE_URL } from '@/config/environment'

Vue.use(Router)
const routes = [
  {
    path: '/login',
    name: routeNames.login.name,
    component: () => import(/* webpackChunkName: 'login' */ '@/views/Login.vue'),
    meta: { requiresAuth: false, showFooter: true },
  },
  {
    path: '/cookies',
    name: routeNames.cookies.name,
    component: () => import(/* webpackChunkName: 'cookies' */ '@/views/Cookies.vue'),
    meta: { requiresAuth: false, showFooter: true },
  },
  {
    path: '/',
    name: routeNames.main.name,
    component: () => import(/* webpackChunkName: 'main' */ '@/views/Main.vue'),
    meta: { requiresAuth: false, showFooter: true },
  },
  {
    path: '/settings',
    name: routeNames.settings.name,
    component: () => import(/* webpackChunkName: 'settings' */ '@/views/Settings.vue'),
    meta: { requiresAuth: true, showFooter: true },
  },
  {
    path: '/accounts',
    name: routeNames.accounts.name,
    component: () => import(/* webpackChunkName: 'accounts' */ '@/views/Accounts.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/booking',
    name: routeNames.booking.name,
    component: () => import(/* webpackChunkName: 'booking' */ '@/views/Booking.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/booking/:bookingId/guest/:guestId',
    name: routeNames.guest.name,
    component: () => import(/* webpackChunkName: 'guest' */ '@/views/Guest.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/checkin',
    name: routeNames.checkin.name,
    component: () => import(/* webpackChunkName: 'checkin' */ '@/views/Checkin.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/guest-checkin/:bookingId/:guestId',
    name: routeNames.guestcheckin.name,
    component: () => import(/* webpackChunkName: 'guestCheckin' */ '@/views/GuestCheckin.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/guest-checkin-completed/:bookingId/:guestId',
    name: routeNames.guestcheckincompleted.name,
    component: () => import(/* webpackChunkName: 'guestCheckinCompleted' */ '@/views/GuestCheckinCompleted.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/password',
    name: routeNames.password.name,
    component: () => import(/* webpackChunkName: 'password' */ '@/views/Password.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/p/:pageId',
    name: routeNames.page_details.name,
    component: () => import(/* webpackChunkName: 'page-details' */ '@/views/pages/Page.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/upcoming-events',
    name: routeNames.upcomingEvents.name,
    component: () => import(/* webpackChunkName: 'upcoming-events' */ '@/views/UpcomingEvents.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/activity-reservation/:activityReservationId/payment',
    name: routeNames.reservationPayment.name,
    component: () => import(/* webpackChunkName: 'reservation-payment' */ '@/views/reservation/Payment.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/p/:pageId/reservation/complete',
    name: routeNames.reservationComplete.name,
    component: () => import(/* webpackChunkName: 'reservation-complete' */ '@/views/reservation/Complete.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/p/:pageId/reservation/error',
    name: routeNames.reservationError.name,
    component: () => import(/* webpackChunkName: 'reservation-error' */ '@/views/reservation/Error.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/p/:pageId/reservation/summary',
    name: routeNames.reservationSummary.name,
    component: () => import(/* webpackChunkName: 'reservation-summary' */ '@/views/reservation/Summary.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/p/:pageId/reservation',
    name: routeNames.reservationCommonData.name,
    component: () => import(/* webpackChunkName: 'reservation-common-data' */ '@/views/reservation/CommonData.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/activity-reservations',
    name: routeNames.activity_reservations.name,
    component: () => import(/* webpackChunkName: 'activity-reservations' */ '@/views/reservation/ActivityReservations.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/p/:pageId/reservation/catalog',
    name: routeNames.reservationCatalog.name,
    component: () => import(/* webpackChunkName: 'reservation-catalog' */ '@/views/reservation/Catalog.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/p/:pageId/reservation/catalog/product/:productId',
    name: routeNames.catalogProductSelection.name,
    component: () => import(/* webpackChunkName: 'product-selection' */ '@/views/reservation/ProductSelection.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/p/:pageId/reservation/catalog/category/:catalogCategoryId',
    name: routeNames.catalogCategorySelection.name,
    component: () => import(/* webpackChunkName: 'category-selection' */ '@/views/reservation/CategorySelection.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/activity-reservation/:activityReservationId/payment-methods',
    name: routeNames.paymentMethods.name,
    component: () => import(/* webpackChunkName: 'payment-methods' */ '@/views/PaymentMethods.vue'),
    meta: { requiresAuth: true, hideLoadingScreen: true },
  },
  {
    path: '/reservation/payment/:status',
    name: routeNames.paymentStatusTrigger.name,
    component: () => import(/* webpackChunkName: 'payment-status-trigger' */ '@/views/reservation/PaymentStatusTrigger.vue'),
    meta: { requiresAuth: true, hideLoadingScreen: true },
  },
  {
    path: '*',
    redirect: { name: routeNames.main.name },
  },
]

const router = new Router({
  mode: 'history',
  base: BASE_URL,
  routes,
})

router.beforeEach(async (to, from, next) => {
  if (store.state.state.initialHistoryCount === null) {
    store.state.state.initialHistoryCount = structuredClone(window.history.length)
  }
  store.state.state.showFooter = to.meta.showFooter || false
  store.state.state.hideLoadingScreen = to.meta.hideLoadingScreen || false

  const options = {}
  
  if (to.query.inactivity_timeout !== undefined) {
    store.state.state.inactivityTimeout = parseInt(to.query.inactivity_timeout)
  }

  if (to.query['x-api-key'] !== undefined) {
    store.commit('auth/replaceAuthToken', to.query['x-api-key'])
  }

  if (from.query['next-url'] || to.query['next-url']) {
    options.path = to.query['next-url'] || from.query['next-url'] || ''
    if (options.path.startsWith('http') && store.getters['auth/authStatus']) {
      window.open(`${ options.path }?x-api-key=${ store.getters['auth/authToken'] }`, '_blank')
    }
    if (options.path) delete from.query['next-url'], to.query['next-url']
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters['auth/authStatus']) {
      store.state.state.firstLoad = true
      next({ name: routeNames.login.name, query: { 'next-url': to.path } })
    } else {
      if (!from.name || from.name === routeNames.login.name) {
        await store.dispatch('me/getSettings').catch(() => {})
      }

      store.state.state.firstLoad = true
      next(options)
    }
  } else {
    if (store.getters['auth/authStatus']) {
      if (!from.name || from.name === routeNames.login.name) {
        await store.dispatch('me/getSettings').catch(() => {})
      }
      store.state.state.firstLoad = true

      if (to.name === routeNames.login.name) {
        if (!from.name) {
          next({ name: routeNames.main.name })
        } else {
          router.go(-2)
          return
        }
      } else {
        next(options)
      }
    } else {
      if (to.name === routeNames.login.name) {
        next()
      } else {
        next(options)
      }
    }

    store.state.state.firstLoad = true
  }
})

export default router
